// axios封装
import axios from 'axios'
// 导入进度条
import nprogress from 'nprogress'
// 引入进度条样式
import 'nprogress/nprogress.css'
// 导入uuid的数据(store仓库)
// import store from '@/store'
// start表示开始，done表示结束
const http = axios.create({
  baseURL: 'http://222.184.236.70:8001/api',
  timeout: 50000,
  headers: { "Content-Type": "application/json;charset=UTF-8" },

})

// 添加请求拦截器
http.interceptors.request.use(
  (config) => {
    
    nprogress.start()
    return config
  },
  (error) => {
    alert('没有相应数据')
    return Promise.reject(error);
  }
)
// 添加响应拦截器
http.interceptors.response.use(
  (response) => {
    nprogress.done()
    // console.log(response)
    return response.data
  },
  (error) => {
    nprogress.done() 
    alert('没有相应数据')
    return Promise.reject(error) }
)
export default http